<template>
  <div>

    <div class="row">
      <div class="col-md-12">



        <KTPortlet
            v-bind="{
            }"
            v-bind:class="{ 'kt-spinner-f': loading }"
        >
          <template v-slot:title>
            <h4 class="">Configurazione</h4>
          </template>
          <template v-slot:body>
            <!--                        <b-form-group-->
            <!--                                label-cols="4"-->
            <!--                                label-cols-lg="2"-->
            <!--                                label-size="sm"-->
            <!--                                label="Small"-->
            <!--                                label-for="input-sm"-->
            <!--                        >-->
            <!--                            <b-form-input id="input-sm" size="sm"></b-form-input>-->
            <!--                        </b-form-group>-->
            <b-form @submit="onSubmit" @reset="onReset">


              <b-form-group
                  label-cols="4"
                  label-cols-lg="2"
                  label="Value"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.param_value"
                    type="text"
                    required
                    placeholder="Inserisci il Valore"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  v-if="isNew() && $store.getters.currentUser.is_admin"
                  label-cols="4"
                  label-cols-lg="2"
                  label="ID Organizzazione"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.organization_id"
                    type="text"
                    required
                    placeholder="ID Organizzazione"
                ></b-form-input>
              </b-form-group>
              <b-button class="pull-right" type="submit" variant="primary">Salva</b-button>
              <b-button type="reset" variant="danger">Indietro</b-button>

            </b-form>
          </template>
        </KTPortlet>
        <!--end:: Widgets/Activity-->
      </div>

    </div>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../store/breadcrumbs.module";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import UserService from "../../../../common/user.service";
import ApiService from "../../../../common/api.service";
import Vue from "vue";

export default {
  data() {
    return {
      loading:false,
      formoptions:{
      },
      form: {
      },

    }
  },
  components: {
    KTPortlet
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Configurazioni", route: "/setting-admin/main/list" },
      { title: !this.isNew()?"Modifica configurazione":"" }
    ]);
  },

  created () {
    this.initialize()
  },
  methods:{
    isNew: function(){
      return !this.currentEditId();
    },
    currentEditId: function(){
      return this.$router.currentRoute.params.id;
    },
    onSubmit(evt) {
      evt.preventDefault()
      //alert(JSON.stringify(this.form))
      this.loading=true;
      let datasend = this.form;


      ApiService.post('settings'+(this.isNew()?'':'/'),datasend,{ })
          .then(({data}) => {
            if(this.isNew()){
              Vue.customNotifySuccess('Salvato');
              this.$router.push({ name: "setting-admin-main-edit", 'params':{'id':data.id} });
              this.loading = false;
              this.reload();
            }else {
              Vue.customNotifySuccess('Salvato');
              this.loading = false;
              this.reload();
            }

          })
          .catch(({response}) => {
            Vue.customNotifyError('Errore',response.data&&response.data.errors?response.data.errors.join(', '):'Si prega di riprovare');
          });
    },
    onReset(evt) {
      this.$router.go(-1);

    },
    initialize () {
      this.reload();
    },
    reload(){
      const that = this;
      if(!this.isNew()) {
        this.loading=true;
        ApiService.get('settings')
            .then(({data}) => {

              this.form = data.find(x => x.id == this.currentEditId());

              this.loading=false;
            })
            .catch(({response}) => {
              //context.commit(SET_ERROR, response.data.errors);
            });
      }
      if(this.isNew() && this.$route.query.organization_id){
        this.form.organization_id = this.$route.query.organization_id;
      }
    },
  }
};
</script>
